var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(this.$route.params.version === 'v1')?_c('create-v1'):_vm._e(),(this.$route.params.version === 'v2')?_c('create-v2'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }